export default __webpack_public_path__ + "static/logo-1ce6ce3f4705767e6f67abcbf381eee0.png";